import { breakPoints } from 'src/theme/defaultTheme';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 48px 64px;
  max-width: 525px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  @media (max-width: ${breakPoints.mb3}px) {
    padding: 32px 16px;
  }
`;
